import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Slider from "react-slick";
import styled from "styled-components";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Clock from "./Clock";
import { carouselNew } from './constants';
import * as selectors from '../../store/selectors';
import { fetchNftsBreakdown } from "../../store/actions/thunks";
import api from "../../core/api";
// import { useNavigate } from 'react-router-dom';
import { useNavigate } from "@reach/router";
import {
  useQuery,
  gql
} from "@apollo/client";

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 260px;
  overflow: hidden;
  border-radius: 8px;
`;

const GET_GREETING = gql`
  query GetMediaItem{
  items{
    id,
    title,
    price,
    pictureUrl,
    accessUrl,
    purchased
  }
}
`;

const CarouselNewRedux = () => {
  const navigate = useNavigate();

    const dispatch = useDispatch();
    const nftsState = useSelector(selectors.nftBreakdownState);
    const nfts = nftsState.data ? nftsState.data : [];
    
    const { loading, error, data } = useQuery(GET_GREETING, {
      // variables: { language: 'english' },
      context: {fetchOptions: {method: 'POST'}}
    });
    console.log("data", loading);
    console.log("data", error);
    console.log("data", data);
    useEffect(() => {
        dispatch(fetchNftsBreakdown());
    }, [dispatch]);

    if (loading) return <p>Loading ...</p>;
    return (
        <div className='nft'>
          <Slider {...carouselNew}>
          {data && data.items.map( (nft, index) => (
            <div className='itm' index={index + 1} key={index}>
              <div className="d-item">
                <div className="nft__item">
                    {/* { nft.deadline &&
                        <div className="de_countdown">
                            <Clock deadline={nft.deadline} />
                        </div>
                    } */}
                    <div className="author_list_pp">
                        <span onClick={()=> window.open("/home1", "_self")}>                                    
                      <img className="lazy" src="/img/author/author-10.jpg" alt="No image" />
                            <i className="fa fa-check"></i>
                        </span>
                    </div>
                    <div className="nft__item_wrap">
                      <Outer>
                        <span>
                        <img src="/img/items/static-2.jpg" className="lazy nft__item_preview" alt="No image" />
                        </span>
                      </Outer>
                    </div>
                    <div className="nft__item_info">
                        <span onClick={()=> window.open("/#", "_self")}>
                            <h4>{nft.title}</h4>
                        </span>
                        <div className="nft__item_price">
                      {nft.price} ETH<span>
                        {/* {nft.bid} */}0
                      </span>
                      <p style={{overflow:"hidden"}}>
                        {nft.accessUrl}
                      </p>
                        </div>
                        <div className="nft__item_action">
                      <span onClick={() => navigate("/ItemDetail/"+nft.id)}>Place a bid</span>
                        </div>
                        <div className="nft__item_like">
                            <i className="fa fa-heart"></i><span>
                              {/* {nft.likes} */}
                              1
                            </span>
                        </div>                                                        
                    </div> 
                </div>
              </div>
            </div>
          ))}
          </Slider>
        </div>
    );
}

export default memo(CarouselNewRedux);
